import { Box, Card, CardBody, Heading, HStack, Icon } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import type { ReactNode } from "react";

interface Props {
  icon: IconType;
  title: string;
  children: ReactNode;
}

export const SectionCard = ({ icon, title, children }: Props) => (
  <Card variant="outline" rounded="xl" bg="smBackground" borderColor="smBorder" boxShadow="sm">
    <Box px={{ base: "4", md: "6" }} py="4" borderBottom="1px solid" borderColor="smBorder">
      <HStack spacing="3" align="center">
        <Icon as={icon} boxSize="5" color="smPrimary" />
        <Heading as="h2" size="md">
          {title}
        </Heading>
      </HStack>
    </Box>
    <CardBody px={{ base: "4", md: "6" }} py={{ base: "5", md: "6" }}>
      {children}
    </CardBody>
  </Card>
);
